import {
  GET_DASHBOARD_STATS_REQUEST,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE,
  GET_MONTHLY_SCAN_STATS_REQUEST,
  GET_MONTHLY_SCAN_STATS_SUCCESS,
  GET_MONTHLY_SCAN_STATS_FAILURE,
  GET_LICENSE_USAGE_REQUEST,
  GET_LICENSE_USAGE_SUCCESS,
  GET_LICENSE_USAGE_FAILURE
} from '../../constants/dashboardConstant/dashboardConstants';

const initialState = {
  stats: null,
  loading: false,
  error: null,
  monthlyStats: null,
  monthlyLoading: false,
  monthlyError: null,
  licenseUsage: null,
  licenseUsageLoading: false,
  licenseUsageError: null
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_STATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload,
        error: null
      };
    case GET_DASHBOARD_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case GET_MONTHLY_SCAN_STATS_REQUEST:
      return {
        ...state,
        monthlyLoading: true,
        monthlyError: null
      };
    case GET_MONTHLY_SCAN_STATS_SUCCESS:
      return {
        ...state,
        monthlyLoading: false,
        monthlyStats: action.payload,
        monthlyError: null
      };
    case GET_MONTHLY_SCAN_STATS_FAILURE:
      return {
        ...state,
        monthlyLoading: false,
        monthlyError: action.payload
      };
    case GET_LICENSE_USAGE_REQUEST:
      return {
        ...state,
        licenseUsageLoading: true,
        licenseUsageError: null
      };
    case GET_LICENSE_USAGE_SUCCESS:
      return {
        ...state,
        licenseUsageLoading: false,
        licenseUsage: action.payload,
        licenseUsageError: null
      };
    case GET_LICENSE_USAGE_FAILURE:
      return {
        ...state,
        licenseUsageLoading: false,
        licenseUsageError: action.payload
      };
    default:
      return state;
  }
};

export default dashboardReducer;